import useMonolithApiMutation from '@/hooks/api/useMonolithApiMutation';
import { buildCacheTabOfBuildPath } from '@/utils/monolithApiRouteService';

const useBuildCacheOfBuildTab = (workspaceSlug: string, buildSlug: string, onSuccess: () => void = () => {}) => {
  const { mutate, isPending, isError } = useMonolithApiMutation(
    buildCacheTabOfBuildPath(workspaceSlug, buildSlug),
    'GET',
    {
      onSuccess: () => {
        onSuccess();
      },
    },
  );

  return {
    submit: () => mutate(null),
    isPending,
    isError,
  };
};

export default useBuildCacheOfBuildTab;
